import {Attributes} from '@components/modal/proparties_modal';

const Stats_item = ({item}: {item?: Attributes}) => {
  return (
    <div className="bg-white/[.30] border dark:border-grey border-light-grey md:w-3/5 px-4 py-5 rounded-lg mb-2">
      <div className="flex justify-between gap-x-2">
        <span className="dark:text-white text-dark-grey font-[700] text-dark-navy lg:text-sm mbl:text-2xs">
          {item?.trait_type}
        </span>
        <span className="dark:text-white text-dark-grey font-[700] text-dark-navy lg:text-sm mbl:text-2xs">
          {item?.value} of {item?.max_value}
        </span>
      </div>
    </div>
  );
};

export default Stats_item;
